export default {
  state: {
    accessDenial: {
      active: false,
      message: ''
    }
  },
  mutations: {
    setAccessDenial (state, payload) {
      state.accessDenial = payload
    }
  },
  actions: {
    setAccessDenial  ({commit}, payload) {
      commit('setAccessDenial', payload)
    }
  },
  getters: {
    accessDenial (state) {
      return state.accessDenial
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/accessDenial.js